/* eslint-disable */
"use strict";

import { ODUtil } from "./../../components/util.js";
import ODLayoutHeader from "./header.js";
import ODLayoutSubheader from "./subheader.js";
import ODLayoutFooter from "./footer.js";

var ODLayoutContent = function() {
    // Private properties
    var _element;

	// Private functions
	var _getHeight = function() {
		var height;

		height = ODUtil.getViewPort().height;

        if (_element) {
            height = height - parseInt(ODUtil.css(_element, 'paddingTop')) - parseInt(ODUtil.css(_element, 'paddingBottom'));
        }

        height = height - ODLayoutHeader.getHeight();
        height = height - ODLayoutSubheader.getHeight();
        height = height - ODLayoutFooter.getHeight();

		return height;
	}

    // Public methods
	return {
		init: function(id) {
            _element = ODUtil.getById(id);
		},

		getHeight: function() {
			return _getHeight();
		},

        getElement: function() {
            return _element;
        }
	};
}();

// Webpack support
if (typeof module !== 'undefined') {
	// module.exports = ODLayoutContent;
}

export default ODLayoutContent;
